// SSR migration: delete this file when switching to ssr: true in react-router.config.ts.
// With real SSR the server renders actual route content, so hydration mismatches are
// genuine bugs — the default entry.client (which logs them) should be restored.
import { startTransition, StrictMode } from 'react'

import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
    {
      onRecoverableError() {},
    },
  )
})
